// extracted by mini-css-extract-plugin
module.exports = {"font-bold":"Input_font-bold__iZVCU","font-italic":"Input_font-italic__c3naH","required":"Input_required__hCzdN","autocomplete-ul":"Input_autocomplete-ul__OmK7f"};